import { useCallback, useEffect, useRef, useState } from "react"

import { useToast } from "@/components/ui"
import { IS_DEV } from "@/lib/constants"

import { useGetVersionQuery } from "../graphql/public-generated-rq"

const POLLING_INTERVAL = 5 * 60 * 1000 // 5 minutes

export const VersionChecker = () => {
  const toastRef = useRef<string | null>(null)
  const toast = useToast()
  const [enabled, setEnabled] = useState(true)

  const showVersionToast = useCallback(() => {
    if (toastRef.current) toast.dismiss(toastRef.current)
    toastRef.current = toast.message("New version available! Please refresh the app.", {
      action: {
        label: "Refresh",
        onClick: () => window.location.reload(),
      },
      showClose: false,
      duration: Infinity,
    })
  }, [toast])

  useEffect(() => {
    function callback() {
      setEnabled(document.visibilityState === "visible")
    }

    document.addEventListener("visibilitychange", callback)
    return () => document.removeEventListener("visibilitychange", callback)
  }, [])

  return (
    <VersionCheckerComponent
      onDifferentVersion={showVersionToast}
      enabled={enabled && !IS_DEV}
    />
  )
}

const VersionCheckerComponent = ({
  onDifferentVersion,
  enabled = true,
}: {
  onDifferentVersion: () => void
  enabled: boolean
}) => {
  useGetVersionQuery(undefined, {
    refetchInterval: POLLING_INTERVAL,
    structuralSharing: (prev, next) => {
      // @ts-expect-error - structuralSharing is not typed correctly https://github.com/TanStack/query/issues/6525
      if (prev && next && prev.schemaVersion.version !== next.schemaVersion.version)
        onDifferentVersion()
      return next
    },
    enabled,
  })
  return null
}
